/**
 * Created by Lior Elrom
 * Date: 8/16/16
 * Time: 10:04 AM
 */

'use strict';

const get = require('lodash.get');
const React = require('react');
const ReactDOM = require('react-dom');
const { localStorage } = require('dibs-browser-storage');
const { PAGE_TYPE } = require('../../utils/pageConstants');
const isPageType = require('../../utils/isPageType');
const { STORAGE } = require('../../utils/checkoutStorageConstants');
import { getUserId } from 'dibs-cookie-jar';

// components
const CheckoutSurvey = require('../../abandonedCheckout/components/CheckoutSurvey');
const CheckoutAutoModal = require('../../abandonedCheckout/components/CheckoutAutoModal').default;

const makeOfferLauncher = require('../../abandonedCheckout/components/makeOfferLauncher');

const thirtyMinutesPassed = (time) => {
    const date = new Date(time);
    return (Date.now() - date.getTime()) / (1000 * 60) >= 0.01;
};

const isBlacklistedPage = isPageType([PAGE_TYPE.CHECKOUT, PAGE_TYPE.ABOUT]);

const preAuthOfferModal = () => (dispatch) => {
    const preAuthOfferModalInfo = localStorage.getItem('checkoutPreAuthOfferModalInfo');
    const surveyInfo = localStorage.getItem(STORAGE.SURVEY_INFO);
    if (preAuthOfferModalInfo) {
        const {
            itemId,
            offerAmount,
            offerCurrency,
            offerMessage,
            sellerId,
            quantity,
            name
        } = preAuthOfferModalInfo;
        makeOfferLauncher({
            item: {
                id: itemId,
                seller: {
                    id: sellerId
                }
            },
            currency: offerCurrency,
            currentStep: 'abandonMakeOffer',
            preloadedState: {
                fields: {
                    offerFieldValue: offerAmount,
                    messageFieldValue: offerMessage,
                    nameFieldValue: name,
                    quantityFieldValue: quantity
                }
            }
        });
        localStorage.setItem('hasSeenPreAuthOfferModal', {itemId});
        dispatch({type: 'noop'});
    }
    if (surveyInfo) {
        const el = window.document.createElement('div');
        root.document.body.appendChild(el);
        ReactDOM.render(
            React.createElement(CheckoutSurvey, {}), el
        );
        dispatch({type: 'noop'});
    }
};

const preAuthOfferModalAndSurveyRule = function preAuthOfferModalAndSurveyRule() {
    if (isBlacklistedPage) {
        return Promise.resolve(false);
    }

    let isAfterTimer;

    // checkoutPreAuthOfferModal display logic
    // if checkoutPreAuthOfferModalInfo is present, it overrides checkoutSurveyInfo
    const preAuthOfferModalInfo = localStorage.getItem('checkoutPreAuthOfferModalInfo');
    if (preAuthOfferModalInfo) {
        const { itemId } = preAuthOfferModalInfo;
        const hasSeenPreAuthOfferModal = itemId === get(localStorage.getItem('hasSeenPreAuthOfferModal'), 'itemId');

        isAfterTimer = thirtyMinutesPassed(preAuthOfferModalInfo.checkoutTime);

        if (!isAfterTimer && !hasSeenPreAuthOfferModal) {
            return Promise.resolve(true);
        }
    }

    // Old checkout survey
    const surveyInfo = localStorage.getItem(STORAGE.SURVEY_INFO);
    const hasSeenSurvey = !!localStorage.getItem('hasSeenCheckoutSurvey');
    if (surveyInfo && !hasSeenSurvey) {
        isAfterTimer = thirtyMinutesPassed(surveyInfo.checkoutTime);
        if (!isAfterTimer) {
            return Promise.resolve(true);
        }
    }

    return Promise.resolve(false);
};

const autoModal = () => (dispatch) => {
    const autoModalInfo = localStorage.getItem(STORAGE.AUTO_MODAL_INFO);

    const { item, email } = autoModalInfo;
    localStorage.deleteItem(STORAGE.SURVEY_INFO);
    localStorage.deleteItem(STORAGE.AUTO_MODAL_INFO);
    setTimeout(() => {
        const div = document.createElement('div');
        document.body.appendChild(div);
        ReactDOM.render(
            <CheckoutAutoModal item={item} email={email} />,
            div
        );
        dispatch({type: 'noop'});
    }, 2000);
};

const autoModalRule = function autoModalRule() {
    const autoModalInfo = localStorage.getItem(STORAGE.AUTO_MODAL_INFO);
    return Promise.resolve(!getUserId(document.cookie) && !isBlacklistedPage && autoModalInfo);
};

export default [
    {
        name: 'preAuthOfferModal',
        rule: preAuthOfferModalAndSurveyRule,
        action: preAuthOfferModal,
        priority: 100
    },
    {
        name: 'autoModal',
        rule: autoModalRule,
        action: autoModal,
        priority: 350
    }
];




// WEBPACK FOOTER //
// ./src/notificationQueue/globalNotifications/abandonCheckout.js